/**
 * Formatação pt-BR — percentual, data, labels de BU.
 * Moeda BRL: ver utils/formatters.ts (fmtBRL), formato único desde Task #40.
 */
const PCT = new Intl.NumberFormat("pt-BR", {
  style: "percent",
  maximumFractionDigits: 2,
  minimumFractionDigits: 2,
});

// Numérico com decimais fixos (MWh, MWm, DV01). Sem símbolo de moeda.
export function numBr(v: number, decimals = 2): string {
  if (Number.isNaN(v)) return "—";
  return v.toLocaleString("pt-BR", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
}

// Percentual com sinal (deltas) — input em %, ex.: 12.5 → "+12,50%".
export function pctSigned(v: number, decimals = 2): string {
  if (Number.isNaN(v)) return "—";
  const sign = v > 0 ? "+" : "";
  return `${sign}${v.toLocaleString("pt-BR", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  })}%`;
}

export function pct(v: string | number): string {
  const n = typeof v === "string" ? Number(v) : v;
  if (Number.isNaN(n)) return "—";
  return PCT.format(n);
}

export function brDate(yyyyMmDd: string): string {
  const [y, m, d] = yyyyMmDd.split("-");
  return `${d}/${m}/${y}`;
}

/**
 * Labels de BU pra UI. "compartilhada" (backend) vira "Corporativo" (UI).
 * Backend não muda — só traduzimos na apresentação.
 */
export function buLabel(bu: string): string {
  const map: Record<string, string> = {
    atacado: "Atacado",
    varejo: "Varejo",
    gestao: "Gestão",
    compartilhada: "Corporativo",
  };
  return map[bu] ?? bu;
}
